import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme } from '@material-ui/core';
import {
    faClipboardUser,
    faKey,
    faBellOn,
} from '@fortawesome/pro-solid-svg-icons';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { Menu, MenuItem } from '../../components/Menu';
import { usePermission } from '../../hooks/usePermission';
import { useLoading } from '../../units/loading';
import { usePartner } from '../../hooks/usePartner';

type MemberActionPageProps = {};

MemberActionPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function MemberActionPage(props: MemberActionPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const { setIsLoading } = useLoading();
    const { permission, isLoading: isPermissionLoading } = usePermission();
    const { isLoading: isPartnerLoading } = usePartner();

    useEffect(() => {
        setIsLoading(isPermissionLoading || isPartnerLoading);
    }, [permission, isPermissionLoading, isPartnerLoading]);

    return (
        <Page>
            <BackAppBar
                title="會員專區"
                onBackClick={() => history.replace('/memberService/action')}
            />
            <PageBody maxWidth="lg">
                <Menu>
                    <MenuItem
                        text="修改基本資料"
                        icon={faClipboardUser}
                        onClick={() => history.push('/member/edit')}
                        description="修改電話、地址"
                    />
                    <MenuItem
                        text="修改密碼"
                        icon={faKey}
                        onClick={() => history.push('/member/changePassword')}
                        description="修改此帳號密碼"
                    />
                    {permission?.permission_notice ? (
                        <MenuItem
                            text="提醒設定"
                            icon={faBellOn}
                            onClick={() => history.push('/member/setAlert')}
                            description="變更提醒方式"
                        />
                    ) : null}
                </Menu>
            </PageBody>
        </Page>
    );
}

export { MemberActionPage };
